module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-keyfigures"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "economy.compare.keyFigures"
    }
  }), _vm._v("\n            Nøgletal\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [(props.row.coverage_percent !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                            "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'total_revenue') ? _c('div', [(props.row.total_revenue !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'coverage') ? _c('div', [(props.row.coverage !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [(props.row.coverage_per_hour !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                            "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'hours_with_customers') ? _c('div', {
          staticClass: "coverage-cell",
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.hours_with_customers !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("rounded")(props.row.hours_with_customers)) + " %\n                            "), (props.row.hours_with_customers) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.hours_with_customers < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(props.row.hours_with_customers) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(props.row.hours_with_customers) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'name') ? _c('div', [_c('strong', [_vm._v(_vm._s(props.row.name))])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 16450828)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd66fa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/components/compareKeyfigures.vue
// module id = 803
// module chunks = 0